import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Container, Input } from 'components/UIElements'
import STRINGS from 'utils/strings'
import Subheader from '../../../components/Subheader'

function VisitFields(props) {
  const {
    children,
    templateVisit,
    templateVisitErrors,
    disabled,
    updateVisitMetadata,
    updateVisit,
    isNewVisitVersion,
    isArmsSupported = false,
    isReadOnlyState,
  } = props
  const { name: visitName, visit_metadata, metadata } = templateVisit
  const { name: nameErr, display_name: displayNameErr } = templateVisitErrors

  useEffect(() => {
    if (visit_metadata?.display_name || metadata?.display_name) {
      updateVisitMetadata({ key: 'display_name', value: visit_metadata?.display_name || metadata?.display_name })
    }
  }, [])

  return (
    <Container>
      <div className='visit-fields'>
        <Subheader subheaderText={STRINGS.visitScheduleVistNameQuestion} />
        <div className='names'>
          <Input
            label='Visit Name'
            disabled={disabled || isReadOnlyState}
            id='visit-name-input'
            className='visit-name-input'
            placeholder={isNewVisitVersion ? STRINGS.visitScreenName : STRINGS.visitName}
            value={visitName || ''}
            onChange={value => updateVisit({ key: 'name', value })}
            spellCheck
            charLimit={100}
            hasError={nameErr && !visitName}
            errorText={nameErr}
          />
          <Input
            label={STRINGS.visitDisplayName}
            disabled={disabled || isReadOnlyState}
            id='visit-display-name-input'
            className='visit-name-input'
            placeholder={isNewVisitVersion ? STRINGS.appScreening : STRINGS.appDisplayName}
            value={visit_metadata?.display_name || metadata?.display_name || ''}
            onChange={value => updateVisitMetadata({ key: 'display_name', value })}
            spellCheck
            charLimit={100}
            hasError={displayNameErr && !(visit_metadata?.display_name || metadata?.display_name)}
            errorText={displayNameErr}
          />
        </div>
        {children}
      </div>
    </Container>
  )
}

VisitFields.propTypes = {
  disabled: PropTypes.bool,
  templateVisitErrors: PropTypes.objectOf(PropTypes.string),
  name: PropTypes.string,
  templateVisit: PropTypes.shape({
    name: PropTypes.string,
    visit_metadata: PropTypes.shape({
      display_name: PropTypes.string,
    }),
  }),
  updateVisit: PropTypes.func,
  updateVisitMetadata: PropTypes.func,
}

export default VisitFields
